import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./OrderSampleList.scss"
import messages from "../../assets/i18n";
import ItemList from '../../containers/ItemList/ItemList'
import { ButtonStandard, OrderSampleFilter } from "../../components";

function OrderSampleList(props) {

	const dispatch = useDispatch();
    const history = useHistory();

	const lang = useSelector(state => state.language.name);
    const filters = useSelector(state => state.orderSample.filter);

	const orderSampleList     = useSelector(state => state.orderSample.orderSampleList);
    const isLoadingList         = useSelector(state => state.orderSample.isLoading);
    const page                  = useSelector(state => state.orderSample.listPage);
    const hasMore               = useSelector(state => state.orderSample.listHasMore);
    const selectedOrderSample = useSelector(state => state.orderSample.selectedOrderSample);
        
    const [isTableEmpty, setIsTableEmpty] = useState(false)

	const pageMessages = messages[lang].orderSampleListPage;
	const titleTable   = messages[lang].orderSampleListPage.tableTitle;
    const titlePage    = messages[lang].orderSampleListPage.inquiry;

	const header = [
		pageMessages.descricao,
		pageMessages.pedidoAmostra,
		pageMessages.pedidoOriginal,
        pageMessages.fornecedor,
		pageMessages.status,
		pageMessages.dataCadastro,
		pageMessages.dataModificacao,
        ""
	];

    useEffect(() => {
		dispatch({
			type: 'GET_ORDER_SAMPLES',
            page: 1,
            filter: filters,
            cleanTable: true
		})
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
		if (selectedOrderSample.id) {
			history.push('/order-sample-details')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedOrderSample]);

    useEffect(() => {
		if (orderSampleList.length > 0) {
			setIsTableEmpty(false)
		} else {
            setIsTableEmpty(true)
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [orderSampleList]);

    const handleHasMore = () => {
		dispatch({
			type: 'GET_ORDER_SAMPLES',
			page: page,
			filter: filters
		})
	}

	const mappedOrderSampleList = () => {
		return orderSampleList.map((item) => {
			return [
                    { 
                        text: item.descricao,
                        maxLength: 200
                    }, 
                    { 
                        text: item.pedidoAmostra,
                        maxLength: 200
                    },
                    { 
                        text: item.pedido,
                        maxLength: 200
                    },
                    { 
                        text: item.nomeFornecedor,
                        maxLength: 200
                    },
                    { 
                        text: item.status ? item.status.descricao : '-',
                        maxLength: 200
                    },
                    item.dataCadastro
                    ?                  
                    {
                        text: item.dataCadastro,
                        type: 'datehour',
                    }
                    :
                    '--/--/----',
                    item.dataModificacao
                    ?                  
                    {
                        text: item.dataModificacao,
                        type: 'datehour',
                    }
                    :
                    '--/--/----',
                    {
						text: <i className="icon-pen" />,
                        onClick: () => {
							dispatch({
								type: 'SET_SELECTED_ORDER_SAMPLE',
								payload: {
                                    id: item.id,
                                    data: item
                                }
							})
						},
					}
				]

		});
	}

    const getOrderSamples = () => {
        dispatch({
			type: 'GET_ORDER_SAMPLES',
            page: 1,
            filter: filters,
            cleanTable: true
		})
	}

	return (
		<div className="subcontractor-list-page">          
            <Container className="pt-3 justify-content-start">
                <Row className="justify-content-between">
                    <Col className="d-flex align-items-center justify-content-start">
                        <span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
                    </Col>
                </Row>
                <OrderSampleFilter />
            </Container>

            <Container className="px-4 d-flex justify-content-end">
            <ButtonStandard
					text={pageMessages.newOrderSample}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => history.push('/order-sample-details')}/>
				<ButtonStandard
					text={pageMessages.search}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => getOrderSamples()}/>
			</Container>

            <Container className="pt-3 justify-content-start">
                <Container className="mt-1 pt-1 mb-4 pb-5">
                    <ItemList
                        header={header}
                        titleTable={titleTable}
                        listTable={mappedOrderSampleList()}
                        isLoading={isLoadingList && orderSampleList.length === 0 ? true : false}
                        isEmpty={isTableEmpty}
                        hasMore={hasMore}
                        handleHasMore={handleHasMore}
                        hasMoreIsLoading={isLoadingList}
                        />
                </Container>
            </Container>            
		</div>
	)
}

export default withRouter(OrderSampleList);